import { createContext, useContext, useState, ReactNode } from 'react';

type Category = string; // Changed from literal union to string to support dynamic categories

interface CategoryContextType {
  selectedCategory: Category;
  setSelectedCategory: (category: Category) => void;
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined);

export function CategoryProvider({ children }: { children: ReactNode }) {
  const [selectedCategory, setSelectedCategory] = useState<Category>('all');

  return (
    <CategoryContext.Provider value={{ selectedCategory, setSelectedCategory }}>
      {children}
    </CategoryContext.Provider>
  );
}

export function useCategory() {
  const context = useContext(CategoryContext);
  if (context === undefined) {
    // Return default values instead of throwing error for standalone usage
    console.warn('useCategory is being used outside of CategoryProvider. Using default values.');
    return {
      selectedCategory: 'all' as Category,
      setSelectedCategory: () => {},
    };
  }
  return context;
}